module.exports = __webpack_public_path__ + "static/media/foodie.24acc906.svg";